<div style="text-align: center">
  <uib-datepicker ng-model="miCtrl.paiddate" class="well well-sm" datepicker-options="miCtrl.dateoptions"></uib-datepicker>
  
  <div  style="margin-bottom: 1em">Zahlung am: {{miCtrl.paiddate | date : 'dd.MM.yyyy'}}</div>
  <!--<div  style="margin-bottom: 1em">max Date: {{miCtrl.dateoptions.maxDate | date : 'dd.MM.yyyy'}}</div>-->
  
  <div style="margin-bottom: 1em"><span class="btn btn-primary" ng-click="miCtrl.setDate(miCtrl.invoice)" data-ng-disabled="!miCtrl.paiddate">
          Zahlung registrieren</span>&nbsp;<span class="btn btn-danger" ng-click="miCtrl.dialog.close()">Schliessen</span>
        </div>
</div>